import {Dispatch, SetStateAction, RefObject} from 'react';
import {DraggableData, DraggableEvent} from 'react-draggable';

export interface IHandleStartDraggingArgs {
    draggableRef: RefObject<HTMLDivElement>;
    setBounds: Dispatch<SetStateAction<{
        left: number;
        top: number;
        bottom: number;
        right: number;
    }>>;
}

export const handleStartDragging = ({
    draggableRef,
    setBounds,
}: IHandleStartDraggingArgs) => (_: DraggableEvent, uiData: DraggableData) => {
    const {clientWidth, clientHeight} = window.document.documentElement;
    const targetRect = draggableRef.current?.getBoundingClientRect();
    if (!targetRect) {
        return;
    }
    setBounds({
        left: -targetRect.left + uiData.x,
        right: clientWidth - (targetRect.right - uiData.x),
        top: -targetRect.top + uiData.y,
        bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
};
